import Store from 'lightningjs-redux';
import { getSearchedHistory, getSearchQuery } from '../../logic/search/search.selectors';

const mapControllers = instance => [
  {
    shouldBeInvokedOnConnect: true,
    selector: getSearchedHistory,
    callback: value => {
      instance.searchHistory = value;
    },
  },
  {
    shouldBeInvokedOnConnect: true,
    selector: getSearchQuery,
    callback: value => {
      instance.query = value;
    },
  },
];

export default Store.control(mapControllers);
